import { IRootPaths } from "~/types/routing";

import { paths as auth } from "~/router/paths/auth";
import { paths as app } from "~/router/paths/app";
import { paths as settings } from "~/router/paths/settings";
import { paths as checkout } from "~/router/paths/checkout";
import { paths as ads } from "~/router/paths/ads";
import { paths as product } from "~/router/paths/product";
import { paths as blog } from "~/router/paths/blog";
import { paths as description } from "~/router/paths/description";
import { paths as content } from "~/router/paths/content";
import { paths as backgroundRemover } from "~/router/paths/background-remover";
import { paths as backgroundGenerator } from "~/router/paths/background-generator";
import { paths as aiModelsPhotoshoot } from "~/router/paths/ai-models-photoshoot";
import { paths as photoEnhancer } from "~/router/paths/photo-enhancer";
import { watermarkRemover } from "~/router/paths/watermark-remover";

export const paths: IRootPaths = {
  auth,
  app,
  checkout,
  settings,
  content,
  ads,
  product,
  blog,
  description,
  "background-remover": backgroundRemover,
  "background-generator": backgroundGenerator,
  "ai-models-photoshoot": aiModelsPhotoshoot,
  "photo-enhancer": photoEnhancer,
  "watermark-remover": watermarkRemover,
};
